/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "890ec3913edc2139ad1b4c1da0e198f29a6a0d39";
